import React, { useState, useEffect } from 'react';
import {
	Box,
	HStack,
	Button,
} from '@chakra-ui/react'
//SMS
import SmsTableList from './sms/TableList';
import PageLoader from '../../../components/Loader/PageLoader';
import VoiceTableList from './voice/TableList';
// Whatsapp 
import WhatsAppTableList from './whatsapp/TableList';
// Whatsapp 
import EmailTableList from './email/TableList';
import { fetchWrapper } from '../../../helpers';
import GoBack from '../../../components/GoBackButton';
import { useParams } from 'react-router-dom';

function List({ getPage, channel_name }) {
	const [loading, setLoading] = useState(false);
	const [listData, setListData] = useState([])
	const channelName = channel_name;

	const { id } = useParams()
	const channel_id = id


	useEffect(() => {
		loadList();
	}, [])

	const loadList = async () => {
		setLoading(true);
		const url = `${process.env.REACT_APP_API_URL}/channel_api_config/list-all?channel_id=${channel_id}`;
		const data = await fetchWrapper.get(url)
		setListData(data.data);
		setLoading(false);
	}









	return (
		<>
			<PageLoader isLoading={loading} />

			<div className="setting_detail_section">

				<HStack justifyContent="space-between">
					<Box style={{ display: 'flex', alignItems: 'center' }}>

						<GoBack /><h2 className="main_heading" style={{ marginLeft: "10px" }}>{channelName} Channels</h2>
					</Box>
					<Box>
						<HStack>

							<Box>

								{channelName === 'SMS' &&
									<Button onClick={() => getPage('createSms', channel_id)} className="mybutton">Add New {channelName} API Account</Button>
								}

								{channel_id === '7' &&
									<Button onClick={() => getPage('createSms', channel_id)} className="mybutton">Add New {channelName} API Account</Button>
								}

							</Box>

							<Box>
								{channelName === 'Whatsapp' &&
									<Button onClick={() => getPage('createWhatsApp', channel_id)} className="mybutton">Add New {channelName} API Account</Button>
								}

								{channelName === 'E-Mail' &&
									<Button onClick={() => getPage('createEmail', channel_id)} className="mybutton">Add New {channelName} API Account</Button>
								}


								{channelName === 'Voice (IVR)' &&
									<Button onClick={() => getPage('createVoice', channel_id)} className="mybutton">Add New {channelName} API Account</Button>
								}



							</Box>

						</HStack>
					</Box>
				</HStack>



				<div className="table_section">

					{channelName === 'SMS' &&
						<SmsTableList list={listData} getPage={getPage} />
					}
					{channel_id === '7' &&
						<SmsTableList list={listData} getPage={getPage} />
					}

					{channelName === 'Voice (IVR)' &&
						<VoiceTableList list={listData} getPage={getPage} />
					}



					{channelName === 'Whatsapp' &&
						<WhatsAppTableList list={listData} getPage={getPage} />
					}

					{channelName === 'E-Mail' &&
						<EmailTableList list={listData} getPage={getPage} />
					}
				</div>

			</div>
		</>
	)
}


export default List
